import React from 'react';

type Props = React.CanvasHTMLAttributes<HTMLCanvasElement>;

const Canvas = React.forwardRef<HTMLCanvasElement, Props>(({ ...rest }, ref) => {
  return <canvas ref={ref} style={{ display: 'block' }} {...rest} />;
});

Canvas.displayName = 'Canvas';

export { Canvas };
